class MapBlock {
    constructor(el, options) {
        this.scope = el;
        this.lat = options.lat;
        this.lng = options.lng;
        this.map = null;
        this.buildMap();
    }
    buildMap() {
        this.map = new google.maps.Map(this.scope, {
            center: { lat: this.lat, lng: this.lng },
            zoom: 14
        });
        this.marker = new google.maps.Marker({
            position: { lat: this.lat, lng: this.lng },
            map: this.map
        });
    }
}